module.exports = __webpack_public_path__ + "img/th.ef221e53.png";